module.exports = __webpack_public_path__ + "img/rider.43adf78a.png";